import React from 'react';
import MaskedInput from 'react-text-mask';

export const ZipCodeInput = ({ id, value, onChange, required = false, disabled = false }) => {
    return (
        <MaskedInput
            id={id}
            mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
            guide={true}
            type='text'
            value={value}
            onChange={onChange}
            required={required}
            disabled={disabled}
        />
    );
};
